import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { COMPETITOR_DNI_PARAM, getCompetitorDniFromSearch } from '../../utils/competitor';

export default function SaleSuccess() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const competitorDni = getCompetitorDniFromSearch(searchParams);
    const backToSales = competitorDni
        ? `/sales?${COMPETITOR_DNI_PARAM}=${competitorDni}`
        : '/sales';

    return (
        <div className="flex justify-center items-center h-[70vh]">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md text-center border-t-8 border-green-500">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                </div>
                <h2 className="text-2xl font-bold mb-2 text-green-700">Listo!</h2>
                <p className="text-gray-600 mb-2">Las entradas fueron enviadas al mail que indicaste</p>
                <p className="text-xs text-gray-500 mb-6">El email incluye un QR por entrada</p>

                <button
                    onClick={() => navigate(backToSales)}
                    className="w-full bg-indigo-600 text-white font-bold py-2 px-4 rounded hover:bg-indigo-700 transition-colors">
                    Volver a comprar
                </button>
            </div>
        </div>
    );
}
